module.exports = __webpack_public_path__ + "fonts/MIpes81D9Yu3bDAPkvPAKTEmAq4waeQtDrwuJZbx.app.ttf";